<template>
  <div class="container page-content">

    <div class="row page-content__heading">
      <div class="col">
        <h1>{{ $t('product_registration.heading') }}</h1>
      </div>
    </div>

    <div class="row page-content__choose-way">
      
      <div class="col-md-6 offset-3 choose-way__box text-center">
        <div class="box__inner">
          <img class="inner__ico inner__ico--online img-fluid" src="@/assets/images/ico-registration-online.png" alt="amica">
          <h2>{{ $t('product_registration.online_heading') }}</h2>
          <div v-html="$t('product_registration.online_content')"></div>
          <router-link class="box__btn" :to="'/product-registration/step-1'">{{ $t('product_registration.online_button') }}</router-link>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import scrollToElement from 'scroll-to-element'

  export default {
    name: 'ProductRegistration',
    mounted () {
      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      })
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;

    .page-content__heading {
      margin-bottom: 40px;
      
      h1 {
        font-size: 34px;
        font-weight: 300;
      }

      .heading__info {
        font-size: 13px;
        padding-top: 10px;
      }
    }

    .page-content__choose-way {
      margin-top: 160px;

      .choose-way__box {

        &.choose-way__box--offline {
           @media only screen and (max-width : 768px) {
             margin-top: 160px;
           }
        }

        .box__inner {
          background: #f1f1f1;
          padding-top: 80px;
          padding-bottom: 40px;
          position: relative;

          .inner__ico {
            position: absolute;
            left: 50%;

            -webkit-transform: translateX(-50%); 
            -moz-transform: translateX(-50%); 
            -ms-transform: translateX(-50%); 
            -o-transform: translateX(-50%); 
            transform: translateX(-50%);

            &.inner__ico--online {
              top: -108px;
            }

            &.inner__ico--offline {
              top: -108px;
            }
          }

          h2 {
            font-size: 24px;
            font-weight: 800;
            text-transform: uppercase;
            margin-bottom: 30px;
          }

          h3 {
            font-size: 24px;
            font-weight: 800;
            text-transform: uppercase;
            margin-top: 40px;
            margin-bottom: 10px;
          }

          & /deep/ p {
            font-size: 14px;
            line-height: 24px;
            margin: 0 auto;
            margin-bottom: 25px;
            max-width: 80%;
          }

          a {
            color: #2d7bb1;
          }

          p.phone {
            color: #e41429;
            font-size: 20px;
            font-weight: 800;
          }

          a.document {
            color: #e41429;
            font-weight: 700;
            font-size: 16px;
          }

          span.separator {
            border-right: 1px #000 solid;
            margin-right: 10px;
            margin-left: 10px;
          }

          a.box__btn {
            background: #e41429;
            color: #fff;
            padding: 15px 25px;
            font-size: 14px;
            display: inline-block;
            margin-top: 10px;

            &:hover {
              background: darken(#e41429, 10%);
              text-decoration: none;
            }
          }
        }

      }
    } 
  }
</style>
